<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g transform="translate(-48 -136) translate(34 112) translate(14 23)">
              <circle cx="10.5" cy="16" r="1" :fill="color" />
              <path
                :stroke="color"
                stroke-width="2"
                d="M1.995 20l8.504-17.762 8.711 17.419L1.995 20z"
              />
              <path
                :fill="color"
                fill-rule="nonzero"
                d="M10.5 8c.513 0 .936.386.993.883L11.5 9v4c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L9.5 13V9c0-.552.448-1 1-1z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
